.privacyPage {
  .title,
  .subtitle,
  .disclaimer {
    display: block;
    text-align: center;
  }

  .title {
    .text-component {
      line-height: 125%;
    }
  }

  .subtitle {
    margin: 1.25rem 0 2.5rem;

    line-height: 140%;
  }

  .disclaimer {
    max-width: 22.1875rem;
    margin: 1.75rem auto 3.875rem;

    @media (min-width: 400px) {
      max-width: 25rem;
    }

    @media (min-width: 769px) {
      max-width: 29rem;
    }

    @media (min-width: 1281px) {
      max-width: 50rem;
    }
  }

  .block {
    max-width: 32rem;
    margin: 0 auto 3rem;

    @media (min-width: 769px) {
      max-width: 40rem;
    }

    @media (min-width: 1281px) {
      max-width: 55.5rem;
    }

    .blockTitle {
      margin-bottom: 1rem;

      line-height: 140%;
    }

    .blockText {
      padding-left: 1.5rem;
      list-style-type: square;

      .listItem {
        font-size: 1.25rem;

        @media (min-width: 1281px) {
          margin-top: 0.125rem;
          margin-bottom: 0.375rem;
        }
      }

      .blockTextSubtitle {
        margin-bottom: 0.75rem;
        margin-left: -1.5rem;
      }

      .blockTextNote {
        margin-top: 0.75rem;
        margin-left: -1.5rem;
      }
    }
  }
}
